import {createColumnHelper} from '@tanstack/react-table'

const columnHelper = createColumnHelper()

export const tableKonfiguracjaColumns = [
    columnHelper.accessor('id', {
            header: 'ID',
            enableColumnFilter: false,
        },
    ),

    {accessorFn: (row) => row.group, header: 'Grupa'},

    {accessorFn: (row) => row.key, header: 'Klucz'},

    {accessorFn: (row) => row.type, header: 'Typ'},

    {accessorFn: (row) => row.desc, header: 'Opis'},


]